module.exports = __webpack_public_path__ + "0ad032b3d07aaf33b160ac4799dda40f.woff2";